import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../variables';
import {
    StaffCompanyGeneralDataRequest,
    StaffCompanyRequest,
    StaffCompanyResponse,
} from '../model/company.model';

@Injectable({ providedIn: 'root' })
export class StaffCompaniesService {
    private readonly companiesUrl: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(BASE_PATH) organizationBasePath: string,
    ) {
        this.companiesUrl = `${organizationBasePath.replace(/\/$/, '')}/api/v1/companies`;
    }

    list(): Observable<StaffCompanyResponse[]> {
        return this.http.get<StaffCompanyResponse[]>(this.companiesUrl);
    }

    getById(companyId: number): Observable<StaffCompanyResponse> {
        return this.http.get<StaffCompanyResponse>(`${this.companiesUrl}/${companyId}`);
    }

    create(request: StaffCompanyRequest): Observable<StaffCompanyResponse> {
        return this.http.post<StaffCompanyResponse>(this.companiesUrl, request);
    }

    update(companyId: number, request: StaffCompanyRequest): Observable<StaffCompanyResponse> {
        return this.http.put<StaffCompanyResponse>(
            `${this.companiesUrl}/${companyId}`,
            request,
        );
    }

    updateGeneralData(
        companyId: number,
        request: StaffCompanyGeneralDataRequest,
    ): Observable<StaffCompanyResponse> {
        return this.http.put<StaffCompanyResponse>(
            `${this.companiesUrl}/${companyId}/general-data`,
            request,
        );
    }

    setStatus(companyId: number, active: boolean): Observable<StaffCompanyResponse> {
        return this.http.patch<StaffCompanyResponse>(
            `${this.companiesUrl}/${companyId}/status`,
            { active },
        );
    }

    clearGeneralData(companyId: number): Observable<void> {
        return this.http.delete<void>(`${this.companiesUrl}/${companyId}/general-data`);
    }

    delete(companyId: number): Observable<void> {
        return this.http.delete<void>(`${this.companiesUrl}/${companyId}`);
    }
}
